module.exports = __webpack_public_path__ + "static/MetroInc_pin-977867df10da33afa3e722cf31d326eb.png";